import getDatalimit from './getDatalimit';

const watchDataLimitStats = [getDatalimit];

export default watchDataLimitStats;
